/**
 * @generated SignedSource<<36aaad4d65ef2a7c2eb56cb3748cf62e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type GraphQLAuditLogCategory = "ALERT" | "DIGEST" | "INCIDENT" | "KNOWLEDGE_CATALOG" | "ONBOARDING" | "SUPPORT_AGENT" | "TEAM" | "%future added value";
export type GraphQLAuditLogType = "ALERT" | "ALERT_DASHBOARD" | "ALERT_NOTIFICATION_INTEGRATION" | "ALERT_WEBHOOK_SUBSCRIPTION" | "ARTICLE_CHUNK" | "CATALOG_INTEGRATION" | "CATALOG_ITEM" | "INCIDENT_RESPONSE_CONFIG" | "INSTRUCTION" | "JOB" | "METRIC_EMBEDDING" | "ONBOARDING_QUESTION" | "ONBOARDING_QUESTION_ANSWER" | "ONBOARDING_QUESTION_ANSWER_FEEDBACK" | "ONBOARDING_TASK_STATUS" | "SUPPORT_AGENT" | "TEAM" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AuditLogsPreview_auditLogs$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly action: string | null | undefined;
      readonly category: GraphQLAuditLogCategory;
      readonly entityType: GraphQLAuditLogType;
      readonly id: any;
      readonly name: string | null | undefined;
      readonly timestamp: any;
      readonly user: {
        readonly email: string;
        readonly firstName: string;
        readonly id: any;
        readonly lastName: string;
      } | null | undefined;
      readonly value: any | null | undefined;
    };
  }>;
  readonly " $fragmentType": "AuditLogsPreview_auditLogs";
};
export type AuditLogsPreview_auditLogs$key = {
  readonly " $data"?: AuditLogsPreview_auditLogs$data;
  readonly " $fragmentSpreads": FragmentRefs<"AuditLogsPreview_auditLogs">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AuditLogsPreview_auditLogs",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLAuditLogEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLAuditLog",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "category",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "timestamp",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphQLUser",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "email",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "action",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLAuditLogConnection",
  "abstractKey": null
};
})();

(node as any).hash = "8c028a09ea5648ac35ef5597670535d4";

export default node;
